import * as yup from 'yup';

const PriorityOptions = [
  { label: 'URGENT', id: 'URGENT' },
  { label: 'MEDIUM', id: 'MEDIUM' },
  { label: 'LOW', id: 'LOW' },
];

const StatusOptions = [
  { label: 'OPEN', id: 'OPEN' },
  { label: 'CLOSED', id: 'CLOSED' },
];

export const ActionConf = {
  schema: yup.object({
    status: yup.mixed().nullable(),
    priority: yup.mixed().nullable(),
  }).test(
    'status-or-priority',
    'Select at least one field',
    (value) => !!value?.status || !!value?.priority
  ),
  defaultValues: {
    status: null,
    priority: null,
  },
  fields: [
    {
      id: 'priority',
      name: 'priority',
      type: 'autocomplete',
      label: 'Priority',
      options: PriorityOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'status',
      name: 'status',
      type: 'autocomplete',
      label: 'Status',
      options: StatusOptions,
      required: false,
      xs: 12,
      sm: 6,
      md: 4,
    },
  ],
};